// @flow
import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {Divider, Typography} from '@material-ui/core';
import CustomButton from '../../../../elements/CustomButton/CustomButton';
import makeStyles from '@material-ui/core/styles/makeStyles';

import CustomModal from '../../../../elements/CustomModal/CustomModal';
import type {Order} from '../../../../entities';
import type {CheckoutRequest} from '../../../manual-order/api';
import {colors} from '../../../../assets/styles/colors';

import type {RootState} from '../../../index';
import type {Dispatch} from 'redux';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {actions as ManualOrderActions} from '../../../manual-order/duck';
import {useCallback} from 'react';
import PaymentForm from '../../../manual-order/components/PaymentForm';

export default connect(
  (state: RootState) => ({
    editOrderSuccess: state.manualOrder.editOrderSuccess,
    editOrderError: state.manualOrder.editOrderError,
  }),
  (dispatch: Dispatch<any>) =>
    bindActionCreators(
      {
        ...ManualOrderActions,
      },
      dispatch
    )
)(EditPaymentInfoModal);

type Props = {
  isSaving?: boolean,
  open: boolean,
  handleClose: () => void,
  order: Order,
  editOrder: ({checkoutRequest: CheckoutRequest}) => void,
};
const useStyles = makeStyles(theme => ({
  root: {
    // padding: theme.spacing(1),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: 340,
  },
  title: {
    alignSelf: 'center',
    fontSize: '1.25rem',
    fontWeight: 600,
    marginTop: theme.spacing(2),
  },
  divider: {
    background: colors.grey200,
    width: '100%',
    margin: theme.spacing(2, 0),
  },
  textField: {
    '&:not(:last-child)': {
      marginBottom: theme.spacing(2),
    },
  },
  button: {
    height: 40,
    fontSize: '1rem',
    alignSelf: 'stretch',
    margin: theme.spacing(2, 0),
  },
}));

function EditPaymentInfoModal(props: Props) {
  const {isSaving, open, handleClose, order, editOrder} = props;
  const classes = useStyles();

  // const {register, handleSubmit, errors} = useForm();
  const [paymentMethodSelected, setPaymentMethodSelected] = useState(
    (order &&
      order.invoice &&
      order.invoice.storePaymentMethodProcessorId &&
      order.invoice.storePaymentMethodProcessorId) ||
      undefined
  );

  const handleCloseModal = useCallback(() => {
    if (!isSaving) {
      handleClose();
    }
  }, [handleClose, isSaving]);

  const handleAmountReceivedSubmit = () => {
    if (paymentMethodSelected !== order.invoice.storePaymentMethodProcessorId) {
      const request: CheckoutRequest = {
        paymentData: {
          storePaymentMethodProcessorId: paymentMethodSelected || '',
        },
      };
      editOrder({checkoutRequest: {id: order.id, request}});
    }
  };

  return (
    <CustomModal open={open} handleCloseModal={handleCloseModal}>
      <div className={classes.root}>
        <Typography className={classes.title} align="center">
          Editar información de cliente
        </Typography>
        <Divider className={classes.divider} />
        {order && (
          <PaymentForm
            paymentMethodSelected={paymentMethodSelected}
            setPaymentMethodSelected={setPaymentMethodSelected}
            // register={register}
            // errors={errors}
            // orderPaid={orderPaid}
            // setOrderPaid={setOrderPaid}
            // tempOrderInfo={{
            //   amountReceived: 123,
            // }}
          />
        )}
        <CustomButton
          className={classes.button}
          variant="contained"
          onClick={handleAmountReceivedSubmit}
          disabled={isSaving}
        >
          Guardar cambios
        </CustomButton>
      </div>
    </CustomModal>
  );
}

EditPaymentInfoModal.propTypes = {
  isSaving: PropTypes.bool,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  order: PropTypes.object.isRequired,
  editOrder: PropTypes.func,
};
